import React from 'react';
import styled from 'styled-components';

interface Category {
  id: string;
  label: string;
}

interface CategorySelectorProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  categories: Category[];
}

const CategorySelector: React.FC<CategorySelectorProps> = ({
  selectedCategory,
  onCategoryChange,
  categories
}) => {
  return (
    <CategorySection>
      <CategoryList>
        {categories.map((category) => (
          <CategoryButton
            key={category.id}
            isSelected={selectedCategory === category.id}
            onClick={() => onCategoryChange(category.id)}
          >
            {category.label}
          </CategoryButton>
        ))}
      </CategoryList>
    </CategorySection>
  );
};

// Styled components
const CategorySection = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const CategoryList = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  padding-bottom: 4px;
`;

const CategoryButton = styled.button<{ isSelected: boolean }>`
  padding: 10px 24px;
  background-color: ${props => props.isSelected ? '#C9A84C' : '#f5f5f5'};
  color: ${props => props.isSelected ? '#fff' : '#171a20'};
  border: 1px solid ${props => props.isSelected ? '#C9A84C' : '#e0e0e0'};
  border-radius: 40px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.15s ease;
  
  &:hover {
    background-color: ${props => props.isSelected ? '#C9A84C' : '#ebebeb'};
  }
`;

export default CategorySelector;